export default __webpack_public_path__ + "static/media/AboutBINKO.fc85db6a.jpg";